import React, { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { leadActivitiesActions, notificationActions } from '@lyra/core';
import { useAppSelector } from '../useStore';

const SocketClient: React.FC = () => {
  const dispatch = useDispatch();
  const socket: any = useAppSelector((state) => state.socket.wss);

  useEffect(() => {
    socket?.on('all-lead-activities-to-client', (leads: any[]) => {
      dispatch(leadActivitiesActions.getLeadActivitiesRequest(leads));
    });
  }, [socket, dispatch]);

  useEffect(() => {
    socket?.on('new-add-lead-activities-to-client', (leadActivities: any) => {
      dispatch(leadActivitiesActions.addLeadActivitiesSuccess(leadActivities));
    });
  }, [socket, dispatch]);

  useEffect(() => {
    socket?.on('all-notifications-to-client', (notifications: any) => {
      dispatch(notificationActions.getNotificationSuccess(notifications));
    });
  }, [socket, dispatch]);

  return null;
};

export { SocketClient };
